import { Category } from "@xanadu/model";
import { DataCache } from "./data.cache";
import { DataService } from "../../service/data/data.service";
import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class CategoryCache extends DataCache<Category> {
    constructor(
        dataService: DataService
    ) {
        super(Category, dataService);
    }
}
